
export let nearest;
export let callback = () => {};

const getServers = () => {
  return fetch(window.API_DOMAIN+'/api/v1/get-jvb-servers');
}

const checkServersLatency = (servers) => {
  var promises = [];
  servers.forEach(async (server) => {
    promises.push(new Promise(async (resolve, reject) => {
      try {
        var t = Date.now();
        fetch('https://' + server + '/ping.txt', {
          mode: 'no-cors',
          cache: 'no-cache'
        }).then(() => {
          var d = Date.now();
          resolve({ server, latency: d - t });
        }).catch(($e) => {
          resolve({ server, latency: 10000 });
        })
      } catch ($e) {
        resolve({ server, latency: 10000 });
      };
    }));
  });
  return Promise.all(promises);
}

if(localStorage.latency) {
  var _nearest = JSON.parse(localStorage.latency);
  nearest = _nearest.sort((a, b) => a.latency - b.latency)[0];
}

getServers().then(res => res.json()).then((servers) => {
  servers = servers.map(server => server.domain);
  checkServersLatency(servers).then((_nearest) => {
    checkServersLatency(servers).then((__nearest) => {
      _nearest = _nearest.concat(__nearest);
      localStorage.latency = JSON.stringify(_nearest);
      nearest = _nearest.sort((a, b) => a.latency - b.latency)[0];
      callback(nearest.server);
    });
  });
});

export function onLatencyCheck(cb) {
  callback = cb
}

export function getNearestServer() {
  if (nearest) {
    return nearest.server;
  } else {
    return false;
  }
}
export function getNearestLatency() {
  if (nearest) {
    return nearest.latency;
  } else {
    return false;
  }
}